import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { Help } from '../../partials/Help/Help';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { RequiredSymbol } from '../../partials/RequiredSymbol/RequiredSymbol';

export type FieldsetModifier = Modifier<'like-label' | 'margin-bottom-20' | 'inline-radios' | 'no-margin'>;

type Fieldset = PropsWithChildren<{
  id?: string;
  legend: string;
  modifier?: FieldsetModifier;
  helpText?: string;
  required?: boolean;
}>;

export function Fieldset({ id, legend, children, modifier, helpText, required }: Fieldset) {
  const helpTextId = useHtmlValidId();

  return (
    <fieldset id={id} className={bem('form2-fieldset', modifier)}>
      <legend className={
        modifier === 'like-label'
          ? 'form2-fieldset__legend font-bold-15-19'
          : 'form2-fieldset__legend font-light-13-17'
      }
      >
        <span className="form2-fieldset__legend-name" aria-describedby={helpText ? helpTextId : undefined}>
          {legend}
          {required && <RequiredSymbol />}
          {helpText && <Help helpText={helpText} id={helpTextId} />}
        </span>
      </legend>
      {children}
    </fieldset>
  );
}
